/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import Button from "../../../component/button/Button";
import { Link } from "react-router-dom";
import isEmpty from "../../../validation/isEmpty";
import {
  CREATED_AS_COLOR,
  CREATED_AS_STATUS,
  SHIFT_COLOR
  // SHIFT_TYPE,
  // CREATED_AS_TYPE
} from "../../../constant/constant";
import { helperFunction } from "../../../constant/helper";
// import { renderShift } from "../../../constant/helper/helper";

const UserList = ({ parentIndex, dailyAttendance, values, zone }) => {
  // console.log(dailyAttendance);
  const renderModalData = (detailAttendance) => {
    return detailAttendance.detections.map(
      (detectionData, childIndex) => (
        <tr key={childIndex}>
          <td>{childIndex + 1}</td>
          <td>{detectionData.Time}</td>
          <td>{detectionData.locationAddress}</td>
          <td>
            {detectionData.AttendanceType}
            {/* {detectionData._id} */}
          </td>
        </tr>
      )
    );
  };
  const renderModalHistoryData = (detailAttendance) => (
    <div className="table-responsive">
      <table
        className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
        id="products-datatable"
      >
        <thead className="thead-light">
          <tr>
            <th>In-Time-History</th>
            <th>Out-Time-History</th>
          </tr>
        </thead>
        <tbody>
          {!isEmpty(detailAttendance.inTimeHistory) && (
            <td>
              {detailAttendance.inTimeHistory.map(
                (historyData, historyIndex) => (
                  <span key={historyIndex}>
                    {helperFunction.TimeStampIntoHours(historyData)},{" "}
                  </span>
                )
              )}
            </td>
          )}
          {!isEmpty(detailAttendance.outTimeHistory) && (
            <td>
              {detailAttendance.outTimeHistory.map(
                (historyData, historyIndex) => (
                  <span key={historyIndex}>
                    {helperFunction.TimeStampIntoHours(historyData)},{" "}
                  </span>
                )
              )}
            </td>
          )}
        </tbody>
      </table>
    </div>
  );

  const attendanceDetailModal = (detailAttendance, parentIndex) => {
    return (
      <div
        id={`full-width-modal${parentIndex}`}
        className="modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="fullWidthModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <HeaderTag
                type="h4"
                className="modal-title mt-2 text-dark"
                isClassName={true}
                id="fullWidthModalLabel"
                title={`Detail Attendance of ${detailAttendance.workerFullName} - ${detailAttendance._id}`}
              />
              <Button
                title="x"
                type="button"
                className="close"
                aria-hidden="true"
                data-dismiss="modal"
                isBackgroundColor={false}
              />
            </div>
            <div className="modal-body">
              <div className="table-responsive">
                <table
                  className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
                  id="products-datatable"
                >
                  <thead className="thead-light">
                    <tr>
                      <th>#</th>
                      <th>Time</th>
                      <th>Location</th>
                      <th>Att-Type</th>
                    </tr>
                  </thead>
                  <tbody>{renderModalData(detailAttendance)}</tbody>
                </table>
              </div>
              <br />
              {renderModalHistoryData(detailAttendance)}
            </div>

            <div className="modal-footer">
              <Button
                type="button"
                title="Close"
                data-dismiss="modal"
                className="btn btn-light"
                isBackgroundColor={false}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <tr style={{ fontSize: "12px" }}>
      <td>{parentIndex + 1}</td>
      <td>
        {moment(
          !isEmpty(dailyAttendance.Date)
            ? dailyAttendance.Date
            : values.date
        ).format("DD-MM-yyyy")}
      </td>
      <td>
        <Link to={`/hr/user/all-users/${dailyAttendance.employeeId}`}>
          {dailyAttendance.workerFullName}
        </Link>
      </td>
      <td>{dailyAttendance.workerId}</td>
      <td>
        <span
          className={
            !isEmpty(dailyAttendance.shiftCode)
              ? SHIFT_COLOR[dailyAttendance.shiftCode.trim()]
              : ""
          }
        >
          {dailyAttendance.shiftCode}
        </span>
      </td>

      <td>{dailyAttendance.inTime}</td>

      <td>{dailyAttendance.outTime}</td>

      {!isEmpty(dailyAttendance?.dataArray) &&
        dailyAttendance.dataArray.map(
          (dynamicValue, dynamicValueIndex) => (
            <td key={dynamicValueIndex}>
              {dynamicValue.label === "Detection Image" ? (
                !isEmpty(dailyAttendance.detectionImages) &&
                dailyAttendance?.detectionImages.map(
                  (imageId, imageIdIndex) => (
                    <strong key={imageIdIndex}>
                      <a
                        href={imageId}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: 10 }}
                      >
                        {" "}
                        Img {imageIdIndex + 1},
                      </a>
                    </strong>
                  )
                )
              ) : dynamicValue.label === "Late" ? (
                <span
                  className={
                    !isEmpty(dailyAttendance?.lateTime)
                      ? "badge badge-danger"
                      : null
                  }
                >
                  {dailyAttendance?.lateTime}
                </span>
              ) : dynamicValue.label === "Over-Time" ? (
                <span
                  className={
                    !isEmpty(dailyAttendance?.overTime)
                      ? "badge badge-primary"
                      : null
                  }
                >
                  {dailyAttendance?.overTime}
                </span>
              ) : (
                dynamicValue?.value || ""
              )}
            </td>
          )
        )}
      <td className="text-center">
        <span>
          {dailyAttendance.duration}
          {/* {dailyAttendance.inCreatedAs} */}
        </span>
      </td>
      <td className="table-action text-center">
        <>
          <span
            className={CREATED_AS_COLOR[dailyAttendance.inCreatedAs]}
          >
            {CREATED_AS_STATUS[dailyAttendance.inCreatedAs]}
          </span>
          -
          <span
            className={CREATED_AS_COLOR[dailyAttendance.outCreatedAs]}
          >
            {CREATED_AS_STATUS[dailyAttendance.outCreatedAs]}
          </span>
        </>
      </td>
      <td className="table-action text-center">
        <span className={CREATED_AS_COLOR[dailyAttendance.createdAs]}>
          {CREATED_AS_STATUS[dailyAttendance.createdAs]}
        </span>
      </td>
      <td className="table-action text-center">
        <span
          className={
            !isEmpty(dailyAttendance.regularizationStatus) &&
            dailyAttendance.regularizationStatus === "REJECTED"
              ? "badge badge-danger"
              : !isEmpty(dailyAttendance.regularizationStatus) &&
                dailyAttendance.regularizationStatus === "APPLIED"
              ? "badge badge-primary"
              : !isEmpty(dailyAttendance.regularizationStatus) &&
                dailyAttendance.regularizationStatus === "APPROVED"
              ? "badge badge-success"
              : null
          }
        >
          {dailyAttendance.regularizationStatus}
        </span>
      </td>
      {values.onOffLocation ? (
        <td className="text-center">
          <i
            className="text-center mdi mdi-map-marker-radius text-primary"
            data-toggle="modal"
            data-target={`#full-width-modal${parentIndex}`}
          >
            Geo-Loc
          </i>
          {attendanceDetailModal(dailyAttendance, parentIndex)}
        </td>
      ) : null}
    </tr>
  );
};

UserList.propTypes = {
  dailyAttendance: PropTypes.object,
  values: PropTypes.object,
  parentIndex: PropTypes.any,
  zone: PropTypes.string
};

export default UserList;
